// extracted by mini-css-extract-plugin
export var dividerContainer = "_8m-0";
export var line = "_8m-1";